export default __webpack_public_path__ + "static/media/Vent-A-Hood@2x.bcfe1039.png";